// extracted by mini-css-extract-plugin
export default {"spinner__con":"styles_spinner__con__3+S6f","spinner":"styles_spinner__uqUe-"};